// Spanish (es) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const es = {
  'show all manuals': 'mostrar todos los manuales',
  eifuPortalIntro:
    'Consulte y descargue las instrucciones de uso electrónicas (eIFU) del software de productos sanitarios de RAY.',
  'Checking the latest documents.': 'Comprobando los documentos más recientes.',
  'There are no manuals to display.': 'No hay manuales para mostrar.',
  Manuals: 'Manuales',
  'Product Name': 'Nombre del producto',
  Language: 'Idioma',
  'Document Name': 'Nombre del documento',
  Product: 'Producto',
  Revision: 'Revisión',
  Document: 'Documento',
  Published: 'Publicado',
  Country: 'País',
  'All countries': 'Todos los países',
  Search: 'Buscar',
  'No results': 'Sin resultados',
  'appManuals.downloadHelpText':
    'Los archivos descargados se pueden visualizar con un navegador de internet o con un software lector de PDF.',
  'appManuals.systemRequirements':
    'Requisitos del sistema: CPU Intel® Core™ i3 o superior, 4 GB de memoria o más, 100 MB o más de espacio de almacenamiento libre para guardar el PDF.',
  'criticalNotice.badge': 'Aviso importante',
  'criticalNotice.close': 'Cerrar',
};

export default es;
